
import {KeyAction, Actions, diversKeys, TemplatePlacemark} from  '@/utils/constant/flight_actions_constantes' ;
import { CamSettings, RouteType} from  '@/utils/constant/flight_settings_constantes' ;
import { CONSTANT_DEVICE } from "@/utils/constant/device.ts";
import Map from "@/utils/Map";

class ApiFlightActions{

  constructor( ) {
    this.init();
  }

  init() {
  }


  // itm : Object JSON correspondant au template d'un ActionGroup KMZ
  getKey(itm){
    let strTrigger = itm.actionTrigger.actionTriggerType
    let strKeyAct = itm.action.actionActuatorFunc
    let strKey = "";
    if(strTrigger === diversKeys.keyTriggerReach ){
      // cas des rotatations Gimbal
      if(strKeyAct === diversKeys.keyCameraRotate){
        let isYaw = parseInt(itm.action.actionActuatorFuncParam.gimbalYawRotateEnable); // 0: GimbalTilt     1: GimbalYaw
        if(isYaw === 1 ){
          strKey = KeyAction.cameraYaw ;
        }
        else{
          strKey = KeyAction.cameraTilt;
        }
      }
      else{
        strKey = strKeyAct;
      }
    }
    else{
      strKey = strTrigger
    }

    return strKey;
  }

  getImg(itm){
    const key = this.getKey(itm);
    return Actions[key].img;
  }

  getTitle(itm){
    const key = this.getKey(itm);
    return  Actions[key].name;
  }

  // pr vérifier u'il s'agit d'une des Actions prises en compte par l'appli
  isActionExist(itm){
    const key = this.getKey(itm);
    const exist  = Actions[key] !== null && Actions[key] !==undefined ? true : false
    return exist
  }


  getArrCoord(objKMZ){
    let arr = new Array();

    if(objKMZ !== undefined && objKMZ.Folder.Placemark !== undefined ){
      objKMZ.Folder.Placemark.forEach(step =>{
        const arrCoord = step.Point.coordinates;
        if(arrCoord.length === 3){
          arr.push([parseFloat(arrCoord[0]), parseFloat(arrCoord[1]), parseFloat(arrCoord[2])]);
        }
      });
    }

    return arr;
  }

  getKeyDrone(objKMZ){
    let devices = CONSTANT_DEVICE.device_type_domain;
    let type = parseInt(objKMZ.missionConfig.droneInfo.droneEnumValue);
    let sub_type = parseInt(objKMZ.missionConfig.droneInfo.droneSubEnumValue);


    let keyDrone = "";
    Object.entries(devices).forEach(([key,value]) => {
      if(value.code.domain === 0 && value.code.type === type && value.code.sub_type === sub_type ){
        keyDrone = value.key;
      }
    });

    return keyDrone;
  }

  getDrone(objKMZ){
    let devices = CONSTANT_DEVICE.device_type_domain;
    let type = parseInt(objKMZ.missionConfig.droneInfo.droneEnumValue);
    let sub_type = parseInt(objKMZ.missionConfig.droneInfo.droneSubEnumValue);


    let drone = {};
    Object.entries(devices).forEach(([key,value]) => {
      if(value.code.domain === 0 && value.code.type === type && value.code.sub_type === sub_type ){
        drone.infos = value;
        drone.droneID = key;
      }
    });

    return drone;
  }


  getInfosVol(objKMZ){
    let obj = {};

    obj.missionConfig = objKMZ.missionConfig;
    RouteType.forEach(type =>{
      if(type.key === objKMZ.Folder.templateType){
        obj.typeroute = type.key ;
        obj.displaynameRoute = type.name;
      }
    })

    // infos du drone
    let drone = this.getDrone(objKMZ);

    obj.drone = drone.infos.code.type + '_' + drone.infos.code.sub_type + '_' + drone.infos.key + '_' + drone.infos.keyCamera + '_' + drone.droneID
    obj.droneID = drone.droneID;
    obj.displaynameDrone = drone.infos.name;


    obj.create_on_site =  $root.global.site.sit_id;

    return obj;
  }

  getLstCameraDrone(objKMZ){
    const keyDroneCamera = this.getKeyDrone(objKMZ);
    if(keyDroneCamera !== ''){
      return CamSettings[keyDroneCamera];
    }
    return []
  }

  getNewPlacemark() {
    const entry = TemplatePlacemark ;
    entry.Point.coordinates = [0.0 ,0.0 , 0.0];

    return entry
  }


  getFirstWayptId(objKMZ){
    if(objKMZ !== undefined && objKMZ.Folder.Placemark !== undefined && objKMZ.Folder.Placemark.length >0 ){
      const firstItem = objKMZ.Folder.Placemark.slice(0,1);

      if(firstItem !== undefined && firstItem !== null)
        return parseInt(firstItem[0].index);
      else
        return null;
    }
    return null;
  }


  getFirstActGrp(objKMZ, stepID){
    if(objKMZ !== undefined && objKMZ.Folder.Placemark !== undefined && objKMZ.Folder.Placemark.length >0) {
      let stepCible = objKMZ.Folder.Placemark.filter(item  => parseInt(item.index) === parseInt(stepID));
      if(stepCible !== undefined && stepCible !== null && stepCible.length > 0 && stepCible[0].actionGroup !== undefined  ){
        // si des items actions présents
        if(stepCible[0].actionGroup.length > 0){
          // on prend le premier, pour extraire le groupID
          return stepCible[0].actionGroup[0] ;
        }
      }
      return null;

    }
    return null;
  }


  getLastActGrp(objKMZ, stepID){
    if(objKMZ !== undefined && objKMZ.Folder.Placemark !== undefined && objKMZ.Folder.Placemark.length >0) {
      let stepCible = objKMZ.Folder.Placemark.filter(item  => parseInt(item.index) === parseInt(stepID));
      if(stepCible !== undefined && stepCible !== null && stepCible.length > 0 && stepCible[0].actionGroup !== undefined  ){
        // si des items actions présents
        if(stepCible[0].actionGroup.length > 0){
          // on prend le dernier, pour extraire le groupID
          return stepCible[0].actionGroup[stepCible[0].actionGroup.length -1] ;
        }
      }
      return null;

    }
    return null;
  }

  getFirstActGrpId(objKMZ, stepID){
    if(objKMZ !== undefined && objKMZ.Folder.Placemark !== undefined && objKMZ.Folder.Placemark.length >0) {
      let stepCible = objKMZ.Folder.Placemark.filter(item  => parseInt(item.index) === parseInt(stepID));
      if(stepCible !== undefined && stepCible !== null && stepCible.length > 0 && stepCible[0].actionGroup !== undefined  ){
        // si des items actions présents
        if(stepCible[0].actionGroup.length > 0){
          // on prend le premier, pour extraire le groupID
          return parseInt(stepCible[0].actionGroup[0].actionGroupId) ;
        }
      }
      return null;

    }
    return null;
  }


  getActionByIds(objKMZ, stepID, actionGrpID){
    if(objKMZ !== undefined && objKMZ.Folder.Placemark !== undefined && objKMZ.Folder.Placemark.length >0){

      let stepCible = objKMZ.Folder.Placemark.filter(item  => parseInt(item.index) === parseInt(stepID));
      if(stepCible !== undefined && stepCible !== null && stepCible.length > 0 && stepCible[0].actionGroup !== undefined  ){

        let grpCible = stepCible[0].actionGroup.filter(item  => parseInt(item.actionGroupId) === parseInt(actionGrpID));
        if(grpCible !== undefined && grpCible !== null && grpCible.length > 0 && grpCible[0].action !== undefined ){
          return grpCible[0].action;
        }
      }
    }

    return;
  }

  getActionsTime(objKMZ) {

    let totalTime =0;
    if(objKMZ !== undefined && objKMZ.Folder.Placemark !== undefined && objKMZ.Folder.Placemark.length >0){
      objKMZ.Folder.Placemark.forEach((placemark) =>{
        if(placemark !== null && placemark !== undefined && placemark.actionGroup !== null && placemark.actionGroup !== undefined && placemark.actionGroup.length > 0){

          placemark.actionGroup.forEach((actgrp) =>{

            if(actgrp !== null && actgrp !== undefined && actgrp.action !== null && actgrp.action !== undefined){
              if(actgrp.action.actionActuatorFunc === "hover" && actgrp.action.actionActuatorFuncParam && actgrp.action.actionActuatorFuncParam.hoverTime) {
                const time = parseInt(actgrp.action.actionActuatorFuncParam.hoverTime);
                if(!isNaN(time)) {
                  totalTime += time;
                }
              }
            }
          });
        }
      });
    }

    return totalTime;
  }



  // pour initialiser pos drone, il faut:
  // droneyaw, gimbaltitl, gimbalyaw, zoom
  // => fct qui loop sur toutes les actiongroup jusqu'à celle définie, et retourne les valeurs de ces 4 variables les plus "à jour"
  // => si aucune précédente occurnece trouvée : retourne 0 pour la variable
  getConfigCamera(objKMZ, step, actgrpIDSelected){
    let isLock = true;
    let isPhoto = false;
    let config ={
      droneyaw:0,
      gimbalyaw:0,
      gimbaltilt:0,
      //zoom *4 par defaut
      zoom:96,
    };
    let YawDecal=0;

    if(objKMZ !== undefined && objKMZ.Folder.Placemark !== undefined ){

      objKMZ.Folder.Placemark.forEach((placemark, id) =>{

        if(id <= step) {
          const isFollow = Map.dynamicmission.isFollow(id);
          const yaw = Map.dynamicmission.getHprHeading(id);
          isPhoto = false;

          if(isFollow == true) {
            config.droneyaw = yaw;
          }

          if(placemark !== null && placemark !== undefined && placemark.actionGroup !== null && placemark.actionGroup !== undefined && placemark.actionGroup.length > 0){
            placemark.actionGroup.forEach((actgrp) =>{

              if(actgrp !== null && actgrp !== undefined && actgrp.action !== null && actgrp.action !== undefined &&
                (parseInt(actgrp.actionGroupId) <= parseInt(actgrpIDSelected) ||  actgrpIDSelected === -1)){

                // on recherche les actions camera zoom, camera yaw, camera title, drone yaw
                if(actgrp.action.actionActuatorFunc === diversKeys.keyCameraRotate && parseInt(actgrp.action.actionActuatorFuncParam.gimbalYawRotateEnable) === 1 ){
                  config.gimbalyaw = actgrp.action.actionActuatorFuncParam.gimbalYawRotateAngle;
                  isLock = false;
                  YawDecal = config.droneyaw - config.gimbalyaw;
                  //console.log("unlocklock decal " + YawDecal);
                }
                else if(actgrp.action.actionActuatorFunc === diversKeys.keyCameraRotate && parseInt(actgrp.action.actionActuatorFuncParam.gimbalPitchRotateEnable) === 1 )
                  config.gimbaltilt = actgrp.action.actionActuatorFuncParam.gimbalPitchRotateAngle;
                else if(actgrp.action.actionActuatorFunc === KeyAction.cameraZoom)
                  config.zoom = actgrp.action.actionActuatorFuncParam.focalLength;
                else if(actgrp.action.actionActuatorFunc === KeyAction.droneyaw)
                  config.droneyaw = actgrp.action.actionActuatorFuncParam.aircraftHeading;
                if(actgrp.action.actionActuatorFunc === KeyAction.snapshotfixedangle && actgrp.action.actionActuatorFuncParamSave.isInit === true) {

                  config.gimbaltilt = actgrp.action.actionActuatorFuncParam.gimbalPitchRotateAngle;
                  if(actgrpIDSelected !== -1) {
                    config.droneyaw = actgrp.action.actionActuatorFuncParam.aircraftHeading;
                    config.gimbalyaw = actgrp.action.actionActuatorFuncParam.gimbalYawRotateAngle;
                    config.zoom = actgrp.action.actionActuatorFuncParam.focalLength;
                    isPhoto = true;
                  }
                }
              }
            });
          }

          //si pas snapshotfixedangle sur le step
          if(isPhoto === false) {
            //Lock Mode
            if(isLock === true) {
              config.gimbalyaw = config.droneyaw;
              //console.log("lock " + config.gimbalyaw);
            }
            else{
              config.gimbalyaw = config.droneyaw - YawDecal;
            }
          }

        }
      });
    }


    return config
  }



  getArrSpeed(objKMZ){
    let arr = new Array();

    if(objKMZ !== undefined && objKMZ.Folder.Placemark !== undefined ){
      objKMZ.Folder.Placemark.forEach(step =>{
        if(step.useGlobalSpeed !== undefined && step.useGlobalSpeed !== null && parseInt(step.useGlobalSpeed) === 1){
          arr.push(parseFloat(objKMZ.Folder.autoFlightSpeed))
        }
        else{
          arr.push(parseFloat(step.waypointSpeed))
        }

      });
    }

    return arr;
  }


  getTakeOffPt(objKMZ){
    if(objKMZ !== undefined && objKMZ !== null && objKMZ.missionConfig !== undefined && objKMZ.missionConfig.takeOffRefPoint !==undefined && objKMZ.missionConfig.takeOffRefPoint  !==null){
      const infostakeoff = objKMZ.missionConfig.takeOffRefPoint ;
      const arrPos = infostakeoff.split(',')

      const takeoffpt = new Cesium.Cartographic(parseFloat(arrPos[1]), parseFloat(arrPos[0]), parseFloat(arrPos[2]))
      return takeoffpt
    }

    return null;
  }

  getGlobalValStatus(objKMZ, index){
    if(objKMZ !== undefined && objKMZ.Folder.Placemark !== undefined && objKMZ.Folder.Placemark.length >0) {
      let stepCible = objKMZ.Folder.Placemark.filter(item  => parseInt(item.index) === parseInt(index));
      if(stepCible !== undefined && stepCible !== null && stepCible[0] !== undefined && stepCible[0] !== null ){

        let hasGlobalValues = false;
        if(stepCible[0].useGlobalHeight && parseInt(stepCible[0].useGlobalHeight) === 1)
          hasGlobalValues = true;
        if(stepCible[0].useGlobalSpeed && parseInt(stepCible[0].useGlobalSpeed) === 1)
          hasGlobalValues = true;
        if(stepCible[0].useGlobalHeadingParam && parseInt(stepCible[0].useGlobalHeadingParam) === 1)
          hasGlobalValues = true;
        if(stepCible[0].useGlobalTurnParam && parseInt(stepCible[0].useGlobalTurnParam) === 1)
          hasGlobalValues = true;

        return hasGlobalValues;
      }
      return false;

    }
  }
}

export default new ApiFlightActions();
